import(/* webpackMode: "eager", webpackExports: ["ImageGenerationSidePanel"] */ "/app/apps/sb-shell/app/(main)/(dark)/ai/image-generation/_components/ImageGenerationSidePanel.tsx");
